<template>
  <div class="axj-main-top-container">
    <div class="axj-main-top">
      <div class="axj-main-top-icon">
        <div class="axj-main-top-logo">
          <img :src="axjMainTopFiles.axjMainTopIconImage">
        </div>
        <div class="axj-main-top-label">
          <label>机构用户管理平台</label>
        </div>
      </div>
      <div class="axj-main-top-tool">
        <div class="axj-main-top-tool-item">
          <label>Hi ! {{user.uname}}</label>
        </div>
        <el-popover
          trigger="click"
        >
         <div class="item" style="height: 30px;font-size: 16px;">
           <label>设置</label>
         </div>
         <div style="height: 30px;font-size: 16px;" @click="logOut" class="item">
           <label>退出</label>
         </div>
          <div class="axj-main-top-tool-item" slot="reference">
            <img :src="axjMainTopFiles.axjMainTopToolMenuIcon">
          </div>
        </el-popover>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "axj-main-top",
  data(){
    return{
      axjMainTopFiles:{
        axjMainTopIconImage:"https://aixuejie-test.oss-cn-hangzhou.aliyuncs.com/axj_web_file/axj_main/image/axj_web_main_top.png",
        axjMainTopToolMenuIcon:'https://img.aixuejie.cn/axj_web_file/icon/axj-menu/menu.png'
      }
    }
  },
  methods:{
    //退出
    logOut(){
      this.$router.replace("/")
      this.$store.dispatch("saveUser",
        {
        uid:undefined,
        uname:undefined,
        avatar:undefined,
        extraShowClubUid:undefined,
        schoolId:undefined})
      this.$store.dispatch("saveLoginInfo",
        {
          uuid:undefined,
          access_token:undefined,
          refresh_token:undefined,
          expires_in:undefined})
    }
  },
  computed:{
    user(){
      return this.$store.getters.getUser
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj-main-top-container{
  background-color: #080C29;
  .axj-main-top{
    width: 981.75px;
    margin: 0 auto;
    display: flex;
    //height: 96.43333333333334px;
    height: 50.4px;
    .axj-main-top-icon{
      display: flex;
      align-items: center;
      //margin-top: 21.18611111111111px;
      .axj-main-top-logo{
        img{
          //width: 169.00500000000002px;
          //height: 40.18055555555555px;
          width: 133.5px;
          height: 33.6px;
        }
      }
      .axj-main-top-label{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 28.71px;
        label{
          font-family: Source Han Sans CN;
          font-style: normal;
          font-weight: normal;
          font-size: 17.533333333333335px;
          line-height: 138.29416666666668%;
          /* identical to box height, or 45px */
          letter-spacing: 0.19875em;
          color: #FFFFFF;
        }
      }
    }
    .axj-main-top-tool{
      display: flex;
      align-items: center;
      margin-left: auto;
      justify-content: space-between;
      min-width: 180px;
      .item{
        width: 100%;
        height: 30px;
      }
      .axj-main-top-tool-item{
        display: flex;
        label{
          font-family: Source Han Sans CN;
          font-style: normal;
          font-weight: normal;
          font-size: 17.2px;
          line-height: 25.569444444444443px;
          /* identical to box height */
          color: #F2F5F8;
        }
        img{
          width: 25px;
        }
      }
      //.axj-main-top-tool-items:not(:first-child){
      //  margin-top: 7.305555555555555px;
      //  width: 50%;
      //  margin-left: auto;
      //  display: flow;
      //  justify-content: space-between;
      //}
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/axj-main/component/axj-main-top/index.vue